require('./baseState.js');

(function(){
  PegasusTemplate.InitializingState = PegasusTemplate.BaseState.extend({
    setup: function(manager, params){
      var launchController = PegasusTemplate.lookupController('launchPlatform');
      if ( launchController.get('isRetrieveComplete') ){
        PegasusTemplate.lookupRouter().send('loadTemplate');
        return;
      }

      PegasusTemplate.Helpers.addOneTimeObserver(launchController, 'isRetrieveComplete', true, function(){
        Em.run.scheduleOnce('afterRender', PegasusTemplate.lookupRouter(), 'send', 'loadTemplate');
      });
    },
    contentInitialized: function(manager, params){
      PegasusTemplate.lookupRouter().send('showTemplate', params);
      Em.run.scheduleOnce('afterRender', this, 'completeTransition');
    },
    completeTransition: function(){
      this.transitionToIdle();
    },
    transitionToPreview: function(){
      PegasusTemplate.loadedTemplate().set('previewContent', PegasusTemplate.canvasInstance.mutateForOut().message );
      PegasusTemplate.lookupRouter().send('showPreview', PegasusTemplate.lookupController('preview').get('content'));
    },
    transitionToIdle: function(){
      PegasusTemplate.stateMachine.transitionTo('idling');
    }
  });
})();
